import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { useUnpublishAllMutation } from "../../api/apiSlice";

export const UnpublishAllView = () => {
  const [unpublishErrything, { isLoading }] = useUnpublishAllMutation();

  const onUnpublishAllClicked = async () => {
    if (!isLoading) {
      try {
        await unpublishErrything().unwrap();
      } catch (err) {
        console.error(
          "Something went wrong while unpublishing everything: ",
          err
        );
      }
    }
  };
  return (
    <Row className="bg-light">
      <hr />
      <h3>Unpublish all! Use if it gets stuck for some reason.</h3>
      <p>
        This button will send an unpublish command for each type. Use this if
        you cant get rid of a question on screen. It **should** never be needed.
      </p>
      <div className="d-md-block">
        <Button variant="danger" onClick={onUnpublishAllClicked}>
          Unpublish All
        </Button>
      </div>
    </Row>
  );
};
